export const tmpIdsMap = {
  '40379': '177',
  '40381': '207',
  '40383': '20',
  '40385': '191',
  '40387': '209',
  '40389': '187',
  '40391': '189',
  '40393': '205',
  '40395': '13',
  '40397': '211',
  '40399': '185',
  '40401': '213',
  '40403': '195',
  '40407': '217',
  '40409': '183',
}

export const customServiceSceneMap = {
  'cj090': '首页',
  'cj091': '商品详情页',
  'cj092': '我的',
  'cj093': '订单详情页',
  'cj094': '订单追踪页',
  'cj095': '退款详情页',
  'cj097': '协商历史',
  'cj099': '分类页-右上角',
  'cj100': '填写订单页-右上角',
  'cj101': '填写订单页-取消提示',
  'cj102': '收银台-右上角',
  'cj103': '收银台-取消提示',
  'cj104': '订单提交页-权益提示',
  'cj105': '三翼鸟场景详情',
  'cj106': '三翼鸟预约报名-店铺列表',
  'cj107': '三翼鸟预约报名-店铺列表-预约报名',
  'cj130': '智家掌柜-我的积分'
}
